import React from 'react'
import { Link, Image } from 'newComponents'
import CtaArrow from '../../../components/ctaArrow'
import ClockIcon from '../../../images/illustrations/small/clock_icon.svg'
import starsBg from '../../../images/webinars/stars_bg.jpg'

import './styles.scss'

const WebinarCards = (props) => {
  const { webinars = {}, future, confirmationPage } = props

  const { past = [], future: futureWebinars = [] } = webinars

  const webinarsArr = future ? futureWebinars : past

  if (!webinarsArr || webinarsArr.length === 0) return null
  if (confirmationPage === true) {
    webinarsArr.splice(6)
  }

  return (
    <>
      {webinarsArr.map((webinar) => {
        const { data, uid } = webinar
        const { category, recording_length: length, subtitle, title } = data
        return (
          <div className="article-card column is-one-third-desktop is-half-tablet" key={title.text}>
            <Link className="card-link" to={confirmationPage ? `/webinars/${uid}` : uid}>
              <div className="bg-white card-container clickable-card">
                <div className="webinar-card-image-container">
                  <Image image={starsBg} className="webinar-card-image" alt="webinar background" />
                  <p className="webinar-category">{category.toUpperCase()}</p>
                </div>
                <div className="card-top webinar-card-top">
                  {length && (
                    <p>
                      <img src={ClockIcon} alt="clock icon" style={{ marginBottom: '-2px' }} />
                      <span className="webinar-length">{length} min</span>
                    </p>
                  )}
                  <h3 className="card-title webinar-card-title">{title.text}</h3>
                  <p>{subtitle.text}</p>
                </div>
                <div className="card-bottom">
                  <span className="cta card-cta">
                    {future ? 'Learn More' : 'Watch Now'}
                    <CtaArrow />
                  </span>
                </div>
              </div>
            </Link>
          </div>
        )
      })}
    </>
  )
}

export default WebinarCards
